module.exports = __webpack_public_path__ + "static/media/integration2.fbf5cd81.png";